import { Button, Stack, Text } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import styled from '@emotion/styled';
import emptyStateImage from './person-watering-lightbulb.svg';

const Container = styled.div`
  max-width: 100%;
`;

const Content = styled(Stack)`
  margin-top: 72px;
  width: 100%;
  align-items: center;
`;

const StyledImg = styled.img`
  max-width: 242px;
  max-height: 160px;
`;

const Info = styled(Stack)`
  align-items: center;
  text-align: center;
  max-width: 416px;
`;

const Header = styled(Text)`
  word-break: break-all;
`;

export const SurveyTemplatesEmptyState = ({
  searchValue,
  onContinue,
}: {
  searchValue: string;
  onContinue: () => void;
}): JSX.Element => {
  const { t } = useTranslation('survey-templates');

  return (
    <Container>
      <Content direction="column" spacing="x3">
        <StyledImg src={emptyStateImage} alt="" />
        <Info direction="column">
          <Header textType="header4" as="h2">
            {t('empty-state.header', { query: searchValue })}
          </Header>
          <Text>{t('empty-state.info')}</Text>
        </Info>
        <Button kind="primary" onClick={onContinue}>
          {t('empty-state.cta')}
        </Button>
      </Content>
    </Container>
  );
};
